function howitWorks(id) {
  const selectedDiv = $(`#${id}`);
  const isHidden = $(selectedDiv).hasClass('hidden');
  if(isHidden) {
    $('.accordionDiv').addClass('hidden');
    $(selectedDiv).removeClass('hidden');
    $('.popup-cta').removeClass('active');
    $(`.popup-cta[data-id='${id}']`).addClass('active');
  } else {
    $(selectedDiv).addClass('hidden');
    $(`.popup-cta[data-id='${id}']`).removeClass('active');
  }
}

function handleInfoToggle(id) {
  const selectedDiv = $(`#${id}`);
  const isHidden = $(selectedDiv).hasClass('hidden');
  if(isHidden) {
    $(selectedDiv).removeClass('hidden');
  } else {
    $(selectedDiv).addClass('hidden');
  }
}

function toggleForm() {
  const isHidden = $('.formMeasure').hasClass('hiddenForm');
  if(isHidden) {
    $('.formMeasure').removeClass('hiddenForm');
    $('.formModalPopup').removeClass('max-w-[480px]');
    $('.formModalPopup').addClass('max-w-[900px]');
  } else {
    $('.formModalPopup').removeClass('max-w-[900px]');
    $('.formModalPopup').addClass('max-w-[480px]');
    $('.formMeasure').addClass('hiddenForm');
  }
}

function toggleFormModal() {
  const isHidden = $('.formModalPopup').hasClass('active');
  if(isHidden) {
    $('.formModalPopup').removeClass('active');
    $('html').removeClass('overflow-hidden');
  } else {
    $('.formModalPopup').addClass('active');
    $('html').addClass('overflow-hidden');
  }
}

function toggleSizeModal() {
  const isHidden = $('.PopupModal-size').hasClass('active');
  if(isHidden) {
    $('.PopupModal-size').removeClass('active');
    $('html').removeClass('overflow-hidden');
  } else {
    $('.PopupModal-size').addClass('active');
    $('html').addClass('overflow-hidden');
  }
}

let active = false;
function toggleMediaType() {
    let toggle = document.querySelector('.toggleMediaType')
    let text = document.querySelector('.toggleMediaType .text')
    active = !active
    if (active) {
        toggle.classList.add('active');
        $(`.client-gallery-images img[data-tag='Celebrities']`).addClass('hidden');
        $(`.client-gallery-images img[data-tag='Clients']`).removeClass('hidden');
        // text.innerHTML = 'N'
    } else {
        toggle.classList.remove('active')
        // text.innerHTML = 'FF'
        $(`.client-gallery-images img[data-tag='Clients']`).addClass('hidden');
        $(`.client-gallery-images img[data-tag='Celebrities']`).removeClass('hidden');
    }
}